import { render, staticRenderFns } from "./rec_city_alarm.vue?vue&type=template&id=12370387&scoped=true&"
import script from "./rec_city_alarm.vue?vue&type=script&lang=js&"
export * from "./rec_city_alarm.vue?vue&type=script&lang=js&"
import style0 from "./rec_city_alarm.vue?vue&type=style&index=0&id=12370387&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12370387",
  null
  
)

export default component.exports